import React from 'react';
import EmailEditor from '../helpers/email-editor/EmailEditor';

function EmailContentStep({
    emailTemplate,
    subjectLine,
    selectedTemplateName,
    editorKey = 'blank-email',
    saveemail,
}) {
    return (
        <div className="animate-fade-in">
            <h3 className="fw-normal text-gray-900 mb-2">Email Content</h3>
            <p className="text-muted mb-3">
                Create the main content of your email using the editor.
                {selectedTemplateName ? (
                    <>
                        {' '}Starting from template <strong>{selectedTemplateName}</strong>.
                    </>
                ) : null}
            </p>

            <div className="mb-6">
                <EmailEditor
                    key={editorKey}
                    loadjson={emailTemplate}
                    emailSubject={subjectLine || 'Email Template'}
                    saveemail={saveemail}
                />
            </div>
        </div>
    );
}

export default EmailContentStep;
